export const getPath = uuid => `/autograder-ruleset/edit/${uuid}`;

export const getGraderPath = cohortId => `/autograde-by-cohort/${cohortId}`;
